import { InputCommon, StyledButton, StyledForm, ClipLoaderCommon } from "@components";
import { ISignUpPassword } from "@interfaces";
import { IHandleChange, IHandleBlur, IHandleSubmit } from "@interfaces";
import { Divider } from "@mui/material";
import styled from "styled-components";
import GoogleLoginButton from "../GoogleLoginButton";
import CustomAppleSignIn from "../AppleLoginButton";
import { theme } from "@utilities";

interface SignUpPasswordProps {
    values: ISignUpPassword;
    handleChange: IHandleChange;
    handleBlur: IHandleBlur;
    handleSubmit: IHandleSubmit;
    isSubmitting: boolean;
}

export const SignUpPasswordComponent = (props: SignUpPasswordProps) => {
    const { values, handleChange, handleBlur, handleSubmit, isSubmitting } = props;

    return (
        <StyledForm onSubmit={handleSubmit}>
            <StyledWrapper>
                <h2 className="heading">Sign Up</h2>
            </StyledWrapper>
            <InputCommon
                name="password"
                handleChange={handleChange}
                handleBlur={handleBlur}
                value={values.password}
                label="Password"
                type="password"
            />
            <InputCommon
                name="ReEnterPassword"
                handleChange={handleChange}
                handleBlur={handleBlur}
                value={values.ReEnterPassword}
                label="Re-enter Password"
                type="password"
            />
            <StyledButton
                $borderRadius={theme.borderRadius.small}
                color={theme.gradients.button}
                disabled={isSubmitting}
                type="submit"
            >
                {isSubmitting ? (
                    <ClipLoaderCommon size={24} color={theme.colors.highlight} margin={0} />
                ) : (
                    "Sign Up"
                )}
            </StyledButton>
            <Divider
                style={{
                    color: "#898D8F",
                    marginTop: "22px",
                    marginBottom: "2px",
                    fontWeight: "bold",
                    fontSize: "12px",
                }}
            >
                OR
            </Divider>
            <CustomAppleSignIn />
            <GoogleLoginButton />
        </StyledForm>
    );
};

const StyledWrapper = styled(StyledForm)`
    .heading {
        font-size: 28px;
        font-style: normal;
        font-weight: 700;
        line-height: 36px;
        letter-spacing: 0em;
        text-align: center;
    }
`;
